import { render, staticRenderFns } from "./KpiSLD.vue?vue&type=template&id=65c86df0&"
import script from "./KpiSLD.vue?vue&type=script&lang=js&"
export * from "./KpiSLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports